import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'img[appHideMissingImage]',
})
export class HideMissingImageDirective {
  constructor(private el: ElementRef) {}

  @HostListener('error')
  onError(): void {
    this.el.nativeElement.style.display = 'none';
  }
}
